import { Transforms } from 'slate';
import type { SlateEditor, TElement } from 'platejs';

import { asEditor } from 'common/components/ContentEditor/utils/editorHelpers';
import { options } from 'common/components/ContentEditor/options';

export const insertFile = (editor: SlateEditor, url: string, name?: string) => {
    const text = { text: name || '' };
    const newFile = {
        type: options.file.type,
        url,
        children: [text],
    };

    Transforms.insertNodes(asEditor(editor), newFile as TElement);
};

export const addOrReplaceFile = (
    editor: SlateEditor,
    url: string,
    name?: string,
    progress?: number
) => {
    const fileNode = editor.api.block({
        match: { type: options.file.type },
    });

    if (fileNode) {
        Transforms.setNodes(
            asEditor(editor),
            { url, progress } as Partial<TElement>,
            { at: fileNode[1] }
        );

        return;
    }

    insertFile(editor, url, name);
};
